import React, { useEffect, useState } from "react";
import axios from "axios";
import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { HREmployee } from "../../types/hr";
import API_CONFIG from "../../config/api";

interface EmployeeAvatarProps {
  employee: HREmployee;
  size?: number | "large" | "small" | "default";
  style?: React.CSSProperties;
}

const EmployeeAvatar: React.FC<EmployeeAvatarProps> = ({
  employee,
  size = "default",
  style,
}) => {
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    let objectUrl = "";

    const fetchPhoto = async () => {
      if (!employee.photo || !employee.id) {
        setPhotoUrl(null);
        return;
      }

      try {
        const response = await axios.get(
          API_CONFIG.apiUrl(`/hr/employees/${employee.id}/photo`),
          { responseType: "blob" }
        );
        objectUrl = window.URL.createObjectURL(response.data);
        if (isMounted) {
          setPhotoUrl(objectUrl);
        } else {
          window.URL.revokeObjectURL(objectUrl);
        }
      } catch (error) {
        if (isMounted) {
          setPhotoUrl(null);
        }
      }
    };

    fetchPhoto();

    return () => {
      isMounted = false;
      if (objectUrl) {
        window.URL.revokeObjectURL(objectUrl);
      }
    };
  }, [employee.id, employee.photo]);
  // Si l'employé a une photo, on l'affiche
  if (employee.photo && photoUrl) {
    // Avec le proxy configuré dans package.json, on utilise un chemin relatif
    return (
      <Avatar
        size={size}
        src={photoUrl}
        style={style}
        alt={`${employee.first_name} ${employee.last_name}`}
        onError={() => {
          console.error("EmployeeAvatar - Image failed to load:", photoUrl);
          return false;
        }}
      />
    );
  }

  // Sinon, on affiche l'avatar par défaut avec les initiales
  return (
    <Avatar
      size={size}
      style={{ backgroundColor: "#1890ff", ...style }}
      icon={<UserOutlined />}
    >
      {employee.first_name?.[0]}
      {employee.last_name?.[0]}
    </Avatar>
  );
};

export default EmployeeAvatar;
